import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import type { KeyboardEventHandler } from "react";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "use-debounce";
import { useEffect, useState, useRef } from "react";
import { cmmsTheme } from "@setup/theme/cmms-theme";

type Props = {
	onKeyDown: KeyboardEventHandler<HTMLDivElement> | undefined;
};

export const SearchFilter = ({ onKeyDown }: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get("search") ?? "";

	const [localSearchText, setLocalSearchText] = useState(search);
	const [debouncedSearchText] = useDebounce(localSearchText, 400);
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		setLocalSearchText(search);
	}, [search]);

	useEffect(() => {
		if (debouncedSearchText !== search) {
			if (debouncedSearchText === "") {
				searchParams.delete("search");
			} else {
				searchParams.set("search", debouncedSearchText);
			}
			setSearchParams(searchParams, { replace: true });
		}
	}, [debouncedSearchText]);

	const handleFilter = (e: any) => {
		setLocalSearchText(e.target.value);
	};

	return (
		<Box position="relative">
			<TextField
				style={{ borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
				label="Search"
				variant="outlined"
				margin="dense"
				onKeyDown={onKeyDown}
				value={localSearchText}
				onChange={handleFilter}
				fullWidth
				autoComplete="off"
				InputProps={{
					style: {
						paddingRight: 45,
						height: cmmsTheme.dimensions.standardInput,
						marginTop: cmmsTheme.spacing.inputOffset,
					},
				}}
			/>
			<i
				className="fa fa-search"
				style={{
					position: "absolute",
					right: 17,
					top: 20,
					cursor: "pointer",
				}}
			/>
		</Box>
	);
};
